"use client"

import { AnnulusContainer, FeatureContainer, PolygonContainer, PolylineContainer } from "@/lib/FeatureTypes"
import { formatArea, formatLength } from "@/lib/geospacial-utils"
import { useEffect, useState } from "react"

interface FeatureData {
  selectedFeatures: FeatureContainer[]
}

export const MapSelectedFeatures: React.FC<FeatureData> = ({ selectedFeatures }) => {
  const [totalPolygonArea, setTotalPolygonArea] = useState(0)
  const [totalPolygonPerimeter, setTotalPolygonPerimeter] = useState(0)
  const [totalLineLength, setTotalLineLength] = useState(0)

  useEffect(() => {
    let calculatedArea = 0;
    let calcualtedBoundary = 0;
    let calculatedLineLength = 0
    selectedFeatures.forEach(f => {
      if (f instanceof PolygonContainer) {
        calculatedArea += google.maps.geometry.spherical.computeArea(f.polygon.getPath())
        calcualtedBoundary += google.maps.geometry.spherical.computeLength(f.polygon.getPath())
      } else if (f instanceof PolylineContainer) {
        calculatedLineLength += google.maps.geometry.spherical.computeLength(f.polyline.getPath())
      } else if (f instanceof AnnulusContainer) {
        calculatedArea += google.maps.geometry.spherical.computeArea(f.polygon.getPaths().getAt(0)) - google.maps.geometry.spherical.computeArea(f.polygon.getPaths().getAt(1))
        calcualtedBoundary += google.maps.geometry.spherical.computeLength(f.polygon.getPath()) + google.maps.geometry.spherical.computeLength(f.polygon.getPath())
      }
    })
    
    setTotalPolygonArea(calculatedArea)
    setTotalPolygonPerimeter(calcualtedBoundary)
    setTotalLineLength(calculatedLineLength)
  }, [selectedFeatures])

  return (
    <>
        Area: {formatArea(totalPolygonArea)}, Perimeter: {formatLength(totalPolygonPerimeter)}, Length: {formatLength(totalLineLength)}
    </>
  )
}